import { generateColumns, ColumnConfig } from "@lib/helpers/TableHelper";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { Typography } from "antd";
import dayjs from "dayjs";
import { ApiParams, UseMutationProps } from "@lib/types/Api";
import CoinPriceTextFormat from "@lib/components/MiniComponents/Others/CoinPriceTextFormat";
import { ManualTransaction } from "@lib/types/Transaction";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { shortenString } from "@lib/helpers/StringHelper";
import { Invoice } from "@lib/types/Billing";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import { TableColumnsProps } from "@lib/types/General";

type Props<T> = TableColumnsProps<T> & {
  deleteQuery?: UseMutationProps<T>;
  setParams: (newParams: Partial<ApiParams>) => void;
  handleSelectInvoice: (invoice: Invoice) => void;
};

const getColumns = <T extends ManualTransaction>(props: Props<T>) => {
  const { messages, deleteQuery, handleSelectInvoice } = props;
  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "ID",
      dataIndex: "id",
      width: "160px",
      render: (id) => (
        <TableIdButton text={`${shortenString(id)}`} textToBeCopied={id} />
      ),
    },
    {
      title: "common.receivedAmount",
      dataIndex: "amount",
      width: "170px",
      align: "right",
      render: (value, r) => (
        <CoinPriceTextFormat
          amount={value}
          currency={r?.currency}
          showCurrency={r?.currency}
          showCurrencyImage
        />
      ),
    },
    {
      title: "common.convertedAmount",
      dataIndex: "convertedAmount",
      width: "200px",
      align: "right",
      render: (value, r) => (
        <CoinPriceTextFormat
          amount={value}
          currency={r?.convertedTo}
          showCurrency={r?.convertedTo}
          showCurrencyImage
        />
      ),
    },
    {
      title: "common.description",
      dataIndex: "description",
    },
    {
      title: `${messages["common.invoice"] as string}`,
      dataIndex: "invoiceId",
      width: "200px",
      render: (v, r) =>
        handleSelectInvoice ? (
          <Typography.Link
            onClick={() => handleSelectInvoice(r.invoice)}
            style={{ cursor: "pointer" }}
          >
            <TableIdButton text={`#${shortenString(r.invoiceId, 20)}`} />
          </Typography.Link>
        ) : (
          <TableIdButton
            text={`#${shortenString(r.invoiceId)}`}
            textToBeCopied={r.invoiceId}
          />
        ),

      filterType: "search",
    },
    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      width: "150px",
      render: (d) => dayjs(d).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: "common.createdBy",
      dataIndex: "createdBy",
      width: "150px",
    },
    {
      title: "common.actions",
      dataIndex: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "90px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="delete"
            onClick={() => deleteQuery?.mutate(record)}
            noLabel
            itemName={"common.walletAddress"}
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};

export default getColumns;
